import { render } from "./ExaminfoCard.vue?vue&type=template&id=854aa0a2&scoped=true"
import script from "./ExaminfoCard.vue?vue&type=script&lang=js"
export * from "./ExaminfoCard.vue?vue&type=script&lang=js"

import "./ExaminfoCard.vue?vue&type=style&index=0&id=854aa0a2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-854aa0a2"]])

export default __exports__